var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6668 22.9585V10.2918C31.6668 7.30626 31.6668 5.81348 30.7393 4.886C29.8118 3.9585 28.319 3.9585 25.3335 3.9585H12.6668C9.68126 3.9585 8.18848 3.9585 7.261 4.886C6.3335 5.81348 6.3335 7.30626 6.3335 10.2918V22.9585",
    fill: "#491ACB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.53773 24.5662L6.36409 22.9585H31.5902L32.4618 24.5662C34.7464 28.7804 35.3155 30.8874 34.447 32.4647C33.5787 34.0418 31.2764 34.0418 26.6717 34.0418H11.328C6.72334 34.0418 4.42099 34.0418 3.55263 32.4647C2.68427 30.8874 3.25317 28.7804 5.53773 24.5662Z",
    fill: "#491ACB",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5415 11.0835L25.998 12.3389C26.6103 12.8667 26.9165 13.1306 26.9165 13.4585C26.9165 13.7864 26.6103 14.0503 25.998 14.5781L24.5415 15.8335",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4585 11.0835L12.002 12.3389C11.3897 12.8667 11.0835 13.1306 11.0835 13.4585C11.0835 13.7864 11.3896 14.0503 12.002 14.5781L13.4585 15.8335",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5832 9.5L17.4165 17.4167",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeb);
export default __webpack_public_path__ + "static/media/web.0ad384ee028e1d8763aecd32de25b5e9.svg";
export { ForwardRef as ReactComponent };